import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import i18n from "@/i18n";

const ContentCtx = createContext({ content: {}, refresh: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});

  const apply = useCallback((items) => {
    const map = {};
    items.forEach((it) => { map[it.key] = it; });
    setContent(map);
    // Inject into i18n: each item.key (e.g. "hero.title") → bundle override per language
    // AT reuses DE content by default; AR falls back to EN if no explicit translation stored.
    const LANG_FALLBACK = { at: "de", ar: "en" };
    ["it", "en", "de", "fr", "es", "at", "ar"].forEach((lng) => {
      const src = LANG_FALLBACK[lng] || lng;
      items.forEach((it) => {
        const v = it[lng] || it[src] || "";
        if (v) i18n.addResource(lng, "translation", it.key, v);
      });
    });
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      apply(data);
    } catch (e) {
      console.error("Failed to load CMS content:", e);
    }
  }, [apply]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ContentCtx.Provider value={{ content, refresh }}>{children}</ContentCtx.Provider>
  );
}

export const useContent = () => useContext(ContentCtx);
